import React from 'react';
import { motion } from 'framer-motion';
import {
  FaShieldAlt,
  FaCamera,
  FaStar,
  FaUsers,
  FaFemale,
  FaChild,
  FaCalendarAlt,
  FaMapMarkedAlt,
  FaUserShield,
  FaParking,
  FaWifi,
  FaHeadset,
} from 'react-icons/fa';
import './TrustBadgesShowcase.css';

const SHOWCASE_ITEMS = [
  { icon: FaShieldAlt, label: 'Verified Property', color: '#0d9488', bg: '#ccfbf1' },
  { icon: FaCamera, label: 'Verified Photos', color: '#2563eb', bg: '#dbeafe' },
  { icon: FaShieldAlt, label: 'Book & Stay Guarantee', color: '#7c3aed', bg: '#ede9fe' },
  { icon: FaStar, label: 'Super Host', color: '#ea580c', bg: '#ffedd5' },
  { icon: FaUsers, label: 'Family Friendly', color: '#0891b2', bg: '#cffafe' },
  { icon: FaFemale, label: 'Women Friendly', color: '#db2777', bg: '#fce7f3' },
  { icon: FaChild, label: 'Child Friendly', color: '#65a30d', bg: '#ecfccb' },
  { icon: FaCalendarAlt, label: 'Long Stay Friendly', color: '#4f46e5', bg: '#e0e7ff' },
  { icon: FaMapMarkedAlt, label: 'Safe Neighborhood', color: '#059669', bg: '#d1fae5' },
  { icon: FaUserShield, label: '24×7 Security', color: '#1e40af', bg: '#dbeafe' },
  { icon: FaParking, label: 'Free Parking', color: '#475569', bg: '#f1f5f9' },
  { icon: FaWifi, label: 'High-Speed Wi-Fi', color: '#0284c7', bg: '#e0f2fe' },
  { icon: FaHeadset, label: '24×7 Customer Support', color: '#b45309', bg: '#fef3c7' },
];

const TrustBadgesShowcase = () => (
  <section className="trust-showcase home-section" aria-labelledby="trust-showcase-title">
    <div className="home-section-header split">
      <div>
        <h2 id="trust-showcase-title" className="home-section-title">
          Book with Confidence
        </h2>
        <p className="home-section-subtitle">
          Trust badges and safety filters help you find verified stays that match your needs.
        </p>
      </div>
    </div>

    <div className="trust-showcase__grid">
      {SHOWCASE_ITEMS.map((item, idx) => {
        const Icon = item.icon;
        return (
          <motion.div
            key={item.label}
            className="trust-showcase__card"
            style={{ '--card-color': item.color, '--card-bg': item.bg }}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ duration: 0.35, delay: idx * 0.04 }}
          >
            <span className="trust-showcase__icon" aria-hidden="true">
              <Icon />
            </span>
            <span className="trust-showcase__label">{item.label}</span>
          </motion.div>
        );
      })}
    </div>
  </section>
);

export default TrustBadgesShowcase;
